module.exports = __webpack_public_path__ + "img/sprite.symbol.a0aeeaaf.svg";